webpackJsonp([23899280101116],{

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(41);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(57);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(56);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(132);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(131);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	if (typeof window !== "undefined" && window.IntersectionObserver) {
	  io = new window.IntersectionObserver(function (entries) {
	    entries.forEach(function (entry) {
	      listeners.forEach(function (l) {
	        if (l[0] === entry.target) {
	          // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	          if (entry.isIntersecting || entry.intersectionRatio > 0) {
	            io.unobserve(l[0]);
	            l[1]();
	          }
	        }
	      });
	    });
	  }, { rootMargin: "200px" });
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  io.observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var Img = function Img(props) {
	  var opacity = props.opacity,
	      onLoad = props.onLoad,
	      _props$transitionDela = props.transitionDelay,
	      transitionDelay = _props$transitionDela === undefined ? "" : _props$transitionDela,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["opacity", "onLoad", "transitionDelay"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: {
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      transitionDelay: transitionDelay,
	      opacity: opacity,
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }
	  }));
	};
	
	Img.propTypes = {
	  opacity: _propTypes2.default.number,
	  transitionDelay: _propTypes2.default.string,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        "div",
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            zIndex: 0,
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden",
	              zIndex: 1
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement("div", {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.25s"
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.25s"
	          }),
	          bgColor && _react2.default.createElement("div", {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        zIndex: 1,
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        "div",
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            zIndex: 0,
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.35s"
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.25s"
	          }),
	          bgColor && _react2.default.createElement("div", {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: ""
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func
	};
	
	exports.default = Image;

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(337);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Project = function Project(_ref) {
	  var title = _ref.title,
	      url = _ref.url,
	      description = _ref.description,
	      sizes = _ref.sizes,
	      index = _ref.index;
	  return _react2.default.createElement(
	    'li',
	    { className: 'flex flex-column flex-row-ns mb3 b--black-20 ' + (index ? 'bt pt4' : 'pt3') },
	    _react2.default.createElement(
	      'div',
	      { className: 'pr3-ns mb0 w-100 w-third-ns' },
	      _react2.default.createElement(
	        'a',
	        { href: url, target: '_blank', className: 'link near-white hover-gold w-100 dt sans-serif' },
	        _react2.default.createElement(_gatsbyImage2.default, {
	          className: 'db',
	          title: title,
	          alt: title,
	          sizes: sizes
	        }),
	        _react2.default.createElement(
	          'h3',
	          { className: 'f4 f5-ns lh-title tc tr-ns' },
	          _react2.default.createElement(
	            'span',
	            { className: 'bg-near-black lh-copy pa1 tracked-tight' },
	            title
	          )
	        )
	      )
	    ),
	    _react2.default.createElement('div', {
	      className: 'w-100 w-two-thirds-ns pl3-ns pt0 f6 f5-l lh-copy near-black georgia',
	      dangerouslySetInnerHTML: { __html: description }
	    })
	  );
	};
	
	exports.default = Project;
	module.exports = exports['default'];

/***/ }),

/***/ 229:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  head: {
	    title: 'Work',
	    meta: [{ name: 'description', content: 'This is some work.' }],
	    links: [{ rel: 'canonical', href: 'https://youfoundron.com/work' }]
	  },
	  body: {
	    projects: [{
	      key: 'icostats',
	      title: 'ICO Stats: Track ICO Performance',
	      url: 'https://icostats.com/',
	      description: '\n          <h3 class=\'mt0 sans-serif tracked-tight\'>Full-Stack Development</h3>\n          <p>A frequently trafficked webapp for purchasing tokens and analyzing ICO statistics. Utilizes <em>React</em>, <em>Redux</em>, <em>Docker</em>, <em>GraphQL</em>, <em>Web3</em>, and the <em>ShapeShift API</em>.</p>\n          <p>\n            Referenced in <a class=\'sans-serif link fw9 black hover-gold\' href=\'https://www.forbes.com/sites/chancebarnett/2017/09/23/inside-the-meteoric-rise-of-icos/\'>Forbes</a>.\n            <br/>\n            Shared frequently on <a class=\'sans-serif link fw9 black hover-gold\' href=\'https://www.reddit.com/r/icocrypto/comments/6ednmu/ico_stats_httpsicostatscom/\'>Reddit</a>.\n          </p>\n        '
	    }, {
	      key: 'porsche',
	      title: 'Porsche: Only A Sports Car',
	      url: 'https://onlyasportscar.com',
	      description: '\n          <h3 class=\'mt0 sans-serif tracked-tight\'>Front-End Development</h3>\n          <p>An animation and analytics heavy micro-site promoting Porsche\'s spring sportscar lineup, overseen by Cramer-Krasselt and The Uprising Creative. Utilizes <em>React</em>, <em>React Router</em>, <em>Redux Sagas</em>, <em>PostCSS</em>, and <em>GreenSock</em>.</p>\n        '
	    }, {
	      key: 'sonos',
	      title: 'Sonos + Spotify: Playlist Potluck',
	      url: 'https://playlistpotluck.sonos.com/',
	      description: '\n          <h3 class=\'mt0 sans-serif tracked-tight\'>Full-Stack Development</h3>\n          <p>A webapp for starting and sharing collaborative playlists with friends overseen by Cornerstone and The Uprising Creative. Utilizes <em>Node</em>, <em>MongoDB</em>, <em>React</em>, <em>Redux</em>, <em>SCSS</em>, and the <em>Spotify API</em>.</p>\n          <p>Featured in <a class=\'sans-serif link fw9 black hover-gold\' href=\'https://techcrunch.com/2016/11/16/spotifys-playlist-potluck-is-a-collaborative-playlist-for-your-parties/\'>TechCrunch</a>.</p>\n        '
	    }, {
	      key: 'nike',
	      title: 'Nike: Techknit Interactive Timeline',
	      url: 'http://www.niketechknit.com/',
	      description: '\n          <h3 class=\'mt0 sans-serif tracked-tight\'>Full-Stack Development</h3>\n          <p>A blog-embedded interactive piece that allows a user to scrub through over a thousand photos tied to time-stamped biometric data. Overseen by Studio 424 and The Uprising Creative. Utilizes <em>jQuery</em>, <em>SASS</em>, and the <em>FitBit API</em>.</p>\n          <p>Featured in <a class=\'sans-serif link fw9 black hover-gold\' target=\'_blank\' href=\'http://news.nike.com/news/nike-tech-knit-nike-sportswear-s-latest-innovation\'>Nike News</a>.</p>\n        '
	    }, {
	      key: 'modestmouse',
	      title: 'Modest Mouse: Linguistic Remix Generator',
	      url: 'http://strangers.modestmouse.com/',
	      description: '\n          <h3 class=\'mt0 sans-serif tracked-tight\'>Back-End Development</h3>\n          <p>A conceptual interactive webapp for algorithmically generating music. Overseen by The Uprising Creative. Utilizes <em>Node</em>, <em>MongoDB</em>, <em>Ampersand</em>, <em>Web Audio</em>, <em>Canvas</em>, and the <em>Twitter API</em>.</p>\n          <p>\n            Featured in\n            <a class=\'sans-serif link fw9 black hover-gold\' target=\'_blank\' href=\'http://pitchfork.com/news/58885-modest-mouse-launch-strangers-to-ourselves-linguistic-remix-generator/\'>Pitchfork</a>\n            and\n            <a class=\'sans-serif link fw9 black hover-gold\' target=\'_blank\' href=\'http://www.stereogum.com/1788295/modest-mouse-launch-a-strangers-to-ourselves-linguistic-remix-generator/news/\'>Stereogum</a>.\n          </p>\n        '
	    }]
	  }
	};
	module.exports = exports['default'];

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _work = __webpack_require__(229);
	
	var _Head = __webpack_require__(55);
	
	var _Head2 = _interopRequireDefault(_Head);
	
	var _Container = __webpack_require__(21);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Project = __webpack_require__(219);
	
	var _Project2 = _interopRequireDefault(_Project);
	
	var _FadeInUp = __webpack_require__(27);
	
	var _FadeInUp2 = _interopRequireDefault(_FadeInUp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var WorkPage = function WorkPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    _Container2.default,
	    null,
	    _react2.default.createElement(_Head2.default, _work.head),
	    _react2.default.createElement(
	      _FadeInUp2.default,
	      null,
	      _react2.default.createElement(
	        'section',
	        { className: 'pv5 georgia mw7 center' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'sans-serif' },
	          'Work'
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          'ol',
	          { className: 'list pl0' },
	          _work.body.projects.map(function (_ref2, i) {
	            var key = _ref2.key,
	                props = _objectWithoutProperties(_ref2, ['key']);
	
	            return _react2.default.createElement(_Project2.default, _extends({
	              key: key,
	              index: i,
	              sizes: data[key].sizes
	            }, props));
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = WorkPage;
	
	// eslint-disable-next-line no-undef
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-work-js-f1a5e04bf0b01823a756.js